var _rect, _rect2, _path, _rect3, _path2, _path3, _path4, _path5, _path6, _path7, _g, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDriveContent1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 167,
    viewBox: "0 0 210 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1.38281,
    width: 117.242,
    height: 148.967,
    rx: 10,
    fill: "#A8B7CB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.89648,
    y: 12,
    width: 102.759,
    height: 128.277,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7588 3C22.7588 1.34315 24.1019 0 25.7588 0H91.4835C93.1403 0 94.4835 1.34315 94.4835 3V11.7242H22.7588V3Z",
    fill: "#374969"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.6553,
    y: 3.51562,
    width: 61.9315,
    height: 15.7242,
    rx: 7,
    stroke: "#374969",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3207 57.3281H18.6211V67.673H28.966V62.1557",
    stroke: "#374969",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3799 60.8195L23.8986 63.5351L29.6558 57.3281",
    stroke: "#374969",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6538 58.056V59.382H44.1718V60.552H45.6538V61.904H44.1718V63.36H42.5338V56.6H44.1718V58.056H45.6538ZM35.0718 60.032C35.0718 58.394 36.4368 57.237 38.2438 57.25C40.0378 57.237 41.3898 58.394 41.3898 60.032C41.3898 61.67 40.0378 62.84 38.2438 62.84C36.4368 62.84 35.0718 61.67 35.0718 60.032ZM36.4238 65.882C36.4108 64.452 37.9578 63.607 40.3758 63.594C42.7548 63.607 44.2758 64.452 44.2758 65.882C44.2758 67.312 42.7548 68.17 40.3758 68.17C37.9578 68.17 36.4108 67.312 36.4238 65.882ZM36.6578 60.032C36.6578 60.942 37.3338 61.475 38.2438 61.462C39.1408 61.475 39.8168 60.942 39.8298 60.032C39.8168 59.161 39.1408 58.602 38.2438 58.602C37.3338 58.602 36.6578 59.161 36.6578 60.032ZM38.0358 65.882C38.0358 66.571 38.8678 66.883 40.3758 66.87C41.8708 66.883 42.6768 66.571 42.6638 65.882C42.6768 65.219 41.8708 64.881 40.3758 64.894C38.8678 64.881 38.0358 65.219 38.0358 65.882ZM52.4171 57.692V58.966H45.9951V57.692H48.4911V56.522H50.1031V57.692H52.4171ZM46.5671 61.514C46.5541 60.227 47.6851 59.356 49.2711 59.356C50.8571 59.356 52.0011 60.227 52.0011 61.514C52.0011 62.814 50.8571 63.672 49.2711 63.672C47.6851 63.672 46.5541 62.814 46.5671 61.514ZM47.7891 66.142C47.8021 64.868 49.3231 64.114 51.7931 64.114C54.2371 64.114 55.7711 64.868 55.7711 66.142C55.7711 67.403 54.2371 68.17 51.7931 68.17C49.3231 68.17 47.8021 67.403 47.7891 66.142ZM48.0751 61.514C48.0751 62.138 48.5431 62.463 49.2711 62.476C49.9991 62.463 50.5061 62.138 50.5191 61.514C50.5061 60.903 49.9991 60.552 49.2711 60.552C48.5431 60.552 48.0751 60.903 48.0751 61.514ZM49.5051 66.142C49.5051 66.675 50.3111 66.948 51.7931 66.948C53.2361 66.948 54.0291 66.675 54.0291 66.142C54.0291 65.596 53.2361 65.349 51.7931 65.336C50.3111 65.349 49.5051 65.596 49.5051 66.142ZM52.5211 62.762V61.462H54.1071V60.448H52.5471V59.148H54.1071V56.6H55.7191V63.984H54.1071V62.762H52.5211ZM61.2085 59.772C61.2085 61.527 62.1445 63.555 64.0425 64.426L63.1325 65.7C61.8455 65.115 60.9355 63.932 60.4285 62.554C59.9085 64.075 58.9595 65.362 57.6205 65.986L56.6845 64.712C58.6085 63.815 59.5835 61.67 59.5965 59.772V59.044H57.1525V57.718H63.5485V59.044H61.2085V59.772ZM64.4325 68.17V56.6H66.0705V61.02H67.7605V62.372H66.0705V68.17H64.4325ZM78.5018 65.544V66.87H67.9198V65.544H70.6238V63.776H69.1418V59.902H75.6678V58.654H69.1158V57.354H77.2798V61.202H70.7538V62.476H77.5398V63.776H75.9018V65.544H78.5018ZM72.2098 65.544H74.3158V63.776H72.2098V65.544Z",
    fill: "#374969"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3207 88.3281H18.6211V98.673H28.966V93.1557",
    stroke: "#374969",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3799 91.8195L23.8986 94.5351L29.6558 88.3281",
    stroke: "#374969",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7438 87.626V96.154H43.1318V93.32H40.9998V94.334H35.4878V88.38H37.1258V90.148H39.3878V88.38H40.9998V89.55H43.1318V87.626H44.7438ZM37.0478 98.962V95.296H38.6858V97.662H44.9778V98.962H37.0478ZM37.1258 93.06H39.3878V91.396H37.1258V93.06ZM40.9998 92.02H43.1318V90.85H40.9998V92.02ZM56.0311 89.082V90.382H46.4371V89.082H50.4151V87.73H52.0271V89.082H56.0311ZM45.9691 98V96.7H50.4151V95.361C48.4651 95.179 47.2691 94.373 47.2691 93.112C47.2691 91.708 48.7901 90.863 51.2211 90.876C53.6261 90.863 55.1731 91.708 55.1731 93.112C55.1731 94.373 53.9641 95.179 52.0271 95.361V96.7H56.5511V98H45.9691ZM48.9331 93.112C48.9331 93.801 49.7261 94.1 51.2211 94.1C52.6901 94.1 53.4961 93.801 53.5091 93.112C53.4961 92.449 52.6901 92.137 51.2211 92.124C49.7261 92.137 48.9331 92.449 48.9331 93.112ZM61.2085 90.226C61.1955 92.306 62.0795 94.386 63.9385 95.27L62.9505 96.57C61.7285 95.959 60.8835 94.828 60.4025 93.437C59.8955 94.932 59.0115 96.154 57.6985 96.804L56.7105 95.478C58.6605 94.581 59.5705 92.371 59.5705 90.226V88.51H61.2085V90.226ZM64.4325 99.17V87.6H66.0705V92.072H67.7605V93.424H66.0705V99.17H64.4325ZM74.3999 88.38C76.2329 88.38 77.5979 89.563 77.5979 91.214C77.5979 92.878 76.2329 94.061 74.3999 94.048C72.5799 94.061 71.1889 92.878 71.2019 91.214C71.1889 89.563 72.5799 88.38 74.3999 88.38ZM70.7079 95.53C72.7749 95.517 75.6349 95.491 78.0919 95.14L78.2219 96.31C75.6609 96.817 72.9179 96.83 70.8899 96.83L70.7079 95.53ZM72.8139 91.214C72.8009 92.137 73.4899 92.657 74.3999 92.67C75.3229 92.657 76.0249 92.137 76.0379 91.214C76.0249 90.317 75.3229 89.784 74.3999 89.784C73.4899 89.784 72.8009 90.317 72.8139 91.214ZM78.7679 99.196V87.6H80.3799V99.196H78.7679ZM91.3553 87.626V96.154H89.7693V93.736H87.1173V92.436H89.7693V91.136H87.2863C86.4673 92.904 84.7903 94.204 82.4633 94.906L81.7873 93.632C84.2443 92.865 85.8043 91.487 86.0773 89.784H82.4113V88.484H87.8453C87.8453 88.965 87.7933 89.42 87.7023 89.862H89.7693V87.626H91.3553ZM83.7633 98.962V95.296H85.4013V97.662H91.6673V98.962H83.7633ZM96.9746 90.226C96.9876 92.397 97.8586 94.516 99.7826 95.348L98.7946 96.648C97.5076 96.024 96.6496 94.867 96.1686 93.437C95.6746 94.958 94.7776 96.206 93.4646 96.856L92.4506 95.53C94.4266 94.633 95.3236 92.397 95.3366 90.226V88.51H96.9746V90.226ZM98.4826 92.54V91.24H100.771V87.6H102.357V99.196H100.771V92.54H98.4826Z",
    fill: "#374969"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2575_3428)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.759,
    y: 21,
    width: 107.241,
    height: 137.242,
    rx: 4,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.259,
    y: 21.5,
    width: 106.241,
    height: 136.242,
    rx: 3.5,
    stroke: "#EFF3F8"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 115.863,
    y: 50,
    width: 81.3799,
    height: 4,
    rx: 2,
    fill: "#DFDFDF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 115.863,
    y: 65,
    width: 81.3799,
    height: 4,
    rx: 2,
    fill: "#DFDFDF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 115.863,
    y: 80,
    width: 81.3799,
    height: 4,
    rx: 2,
    fill: "#DFDFDF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 115.863,
    y: 95,
    width: 81.3799,
    height: 4,
    rx: 2,
    fill: "#DFDFDF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 115.863,
    y: 110,
    width: 81.3799,
    height: 4,
    rx: 2,
    fill: "#DFDFDF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 115.863,
    y: 125,
    width: 57.9315,
    height: 4,
    rx: 2,
    fill: "#DFDFDF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2575_3428",
    x: 94.7593,
    y: 21,
    width: 115.241,
    height: 145.242,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2575_3428"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2575_3428",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDriveContent1);
export default __webpack_public_path__ + "static/media/IcDriveContent1.d4763a99c20790509ca1218aacd870ee.svg";
export { ForwardRef as ReactComponent };